export default __webpack_public_path__ + "b8601866a4234dc5002eb13c468292cc.woff";